'use client';

import dynamic from 'next/dynamic';

const CookieConsentBanner = dynamic(
  () => import('@/components/CookieConsentBanner').then((m) => m.CookieConsentBanner),
  { ssr: false }
);

const NewsletterPopup = dynamic(
  () => import('@/components/NewsletterPopup').then((m) => m.NewsletterPopup),
  { ssr: false }
);

export function DeferredOverlays() {
  return (
    <>
      <CookieConsentBanner />
      <NewsletterPopup />
    </>
  );
}
